export default __webpack_public_path__ + "static/media/img-0678-bosnia-full-face.bf293624.png";